import type { RawHtmlBlockProps } from '../types';

/**
 * The ONLY block that injects HTML — the migration shim for legacy pages.
 * Trusted solely because the write path is gated to authenticated staff (see
 * CLAUDE.md + docs/BLOCK_MODEL_MIGRATION.md). If self-serve tenants ever gain the
 * ability to edit raw_html, this becomes an XSS sink: sanitize at write time or
 * remove the block type. Native blocks must never use dangerouslySetInnerHTML.
 */
export function RawHtmlBlock({ html }: RawHtmlBlockProps) {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
